import ChatBubbleOutlineIcon from '@mui/icons-material/ChatBubbleOutline';
import React, { useState, useRef, useEffect } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import HomeIcon from '@mui/icons-material/Home';
import EditIcon from '@mui/icons-material/Edit';
import FlightTakeoffIcon from '@mui/icons-material/FlightTakeoff';
import Person4Icon from '@mui/icons-material/Person4';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import SignaturePad from 'react-signature-pad-wrapper';
import ReplayIcon from '@mui/icons-material/Replay';
import ClearIcon from '@mui/icons-material/Clear';
import "../index.css";
import axios from 'axios';
import Footer from './Common_Components/Footer';
// import translations from './translation';
const parseQuestionText = (text) => {
    if (!text) return [];

    const labels = ['Kunyomi:', 'Onyomi:', 'Meaning:'];
    const markers = [];
    
    for (let label of labels) {
        const idx = text.search(new RegExp(label, 'i'));
        if (idx !== -1) {
            markers.push({ label, index: idx });
        }
    }

    markers.sort((a, b) => a.index - b.index);

    const segments = [];

    if (markers.length > 0) {
        let charPart = text.substring(0, markers[0].index).trim();
        if (charPart.endsWith(',')) {
            charPart = charPart.substring(0, charPart.length - 1).trim();
        }
        if (charPart) {
            segments.push(charPart);
        }
    } else {
        segments.push(text.trim());
    }

    for (let i = 0; i < markers.length; i++) {
        const start = markers[i].index;
        const end = (i + 1 < markers.length) ? markers[i + 1].index : text.length;
        
        let part = text.substring(start, end).trim();
        if (part.endsWith(',')) {
            part = part.substring(0, part.length - 1).trim();
        }

        const colonIdx = part.indexOf(':');
        if (colonIdx !== -1) {
            const labelText = part.substring(0, colonIdx + 1).trim();
            const valueText = part.substring(colonIdx + 1).trim();
            
            const formattedValue = valueText.split(',').map(v => v.trim()).filter(Boolean).join('; ');
            
            segments.push(`${labelText} ${formattedValue}`);
        } else {
            segments.push(part);
        }
    }

    return segments;
};

function WritingPratice() {
    const location = useLocation();
    const [activePage, setActivePage] = useState("");
    const navigate = useNavigate();
    const day = location.state?.day || "Day Module";
    const SelectLanguageLocal = localStorage.getItem("selectedLanguage");


    const signaturePadRef = useRef(null);
    const { categoryId, level_id, categoryName, dayId } = location.state || {};
    // const { dayId } = location.state || {};
    const [category_id, setCategoryId] = useState(null);
    const [selectedOption, setSelectedOption] = useState(null);
    const [quizData, setQuizData] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [currentPage, setCurrentPage] = useState(0);
    const [timeSpent, setTimeSpent] = useState(0);
    const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0);
    const [showSubmitMessage, setShowSubmitMessage] = useState(false);
    const [attemptStatus, setAttemptStatus] = useState(null);
    const [hasMoreQuestions, setHasMoreQuestions] = useState(true);
    const [attemptstatus22, setAttemptStatus22] = useState();
    const [attemptedQuestions, setAttemptedQuestions] = useState(0);
    const authToken = localStorage.getItem("AuthToken");
    const [language, setLanguage] = useState('english');
    const [text, setText] = useState({});
    const videoRef = useRef(null); // Create a reference to the video element
    const [isPlaying, setIsPlaying] = useState(false);
    const togglePlayPause = () => {
        if (isPlaying) {
            videoRef.current.pause(); // Pause the video if it's playing
        } else {
            videoRef.current.play(); // Play the video if it's paused
        }
        setIsPlaying(!isPlaying); // Toggle play/pause state
    };
    const handleRepeatVideo = () => {
        if (videoRef.current) {
            videoRef.current.currentTime = 0;
            videoRef.current.playbackRate = 2;
            videoRef.current.play().catch(err => {
                console.log("Repeat playback failed: ", err);
            });
        }
    };
    const formatField = (value) => {
        if (!value) return '';
        if (Array.isArray(value)) {
            return value.map(val => String(val).trim()).filter(Boolean).join('; ');
        }
        if (typeof value === 'string') {
            return value.split(/[,;]/).map(val => val.trim()).filter(Boolean).join('; ');
        }
        return String(value).trim();
    };
    const handleClear = () => {
        if (signaturePadRef.current) {
            signaturePadRef.current.clear();
        }
    };

    const handleUndo = () => {
        const data = signaturePadRef.current.toData();
        if (data) {
            data.pop(); // Remove the last stroke
            signaturePadRef.current.fromData(data);
        }
    };
    // const japaneseQuestions = ["さ", "し", "す", "せ", "そ"];
    // const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0);
    useEffect(() => {
        const loadLanguage = async () => {
            try {
                const storedLanguage = await localStorage.getItem('selectedLanguage');
                setLanguage(storedLanguage || 'english');
            } catch (error) {
                console.error('Error loading language:', error);
            }
        };

        loadLanguage();
    }, []);

    // useEffect(() => {
    //     setText(translations[language]);
    // }, [language]);

    const ref = useRef();
    const [onOK, setonOk] = useState();

    const handleOK = signature => {
        console.log(signature);
    };

    // const handleClear = () => {
    //     ref.current.clearSignature();
    // };
    // const handleUndo = () => {
    //     ref.current.undo();
    // };

    const handleConfirm = () => {
        console.log('end');
        ref.current.readSignature();
    };
    const style = `.m-signature-pad--footer {display: none; margin: 0px;}`;

    useEffect(() => {
        fetchQuizData(currentPage);
    }, [currentPage]);



    useEffect(() => {
        const timer = setInterval(() => {
            setTimeSpent(prevTime => prevTime + 1);
        }, 1000);
        return () => clearInterval(timer);
    }, []);

    useEffect(() => {
        if (videoRef.current) {
            videoRef.current.load();
            videoRef.current.playbackRate = 2;
            videoRef.current.play().catch(err => {
                console.log("Auto-play failed/prevented: ", err);
            });
        }
    }, [currentQuestionIndex]);


    console.log("this is category id and page id are on writing module " + categoryId, dayId)

    const fetchQuizData = async page => {
        setIsLoading(true);
        try {
            const response = await axios.get(
                `https://api.japaking.online/api/categories/question/day?categoryId=${categoryId}&dayId=${dayId}`,
                {
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${authToken}`,
                    },
                }
            );
            if (response.data.success) {
                const newQuestions = response.data.message.category;
                setQuizData(prevData => [
                    ...prevData,
                    ...newQuestions.filter(
                        q => !prevData.some(p => p.question_id === q.question_id),
                    ),
                ]);
                if (newQuestions.length < 6) {
                    setHasMoreQuestions(false);
                }
            }
        } catch (err) {
            if (err.response && err.response.status === 401) {
                console.log("navigate to login due to 401");
                navigate("Login");
            }
            console.log('Error fetching quiz data:', err);
        } finally {
            setIsLoading(false);
        }
    };

    const handleSelect = optionId => {
        setSelectedOption(optionId);
    };

    const submitUserAttempt = async () => {
        const currentQuestion = quizData[currentQuestionIndex];
        const selectedOptionData = currentQuestion.options.find(
            option => option.option_id === selectedOption,
        );
        const userAttemptData = {
            questionId: currentQuestion.question_id,
            optionId: selectedOption,
            attemptStatus: selectedOptionData
                ? selectedOptionData.is_correct
                    ? 'correct'
                    : 'incorrect'
                : null,
        };
        // console.log(userAttemptData, "userAttemptData");
        try {
            const response = await axios.post(
                `https://api.japaking.online/api/userAttempts`,
                userAttemptData,
                {
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${authToken}`,
                    },
                }
            );
            // console.log('User attempt submitted successfully:', response?.data);

            setAttemptStatus(response.data.message.attempt.attempt_status);
            setAttemptStatus22(response?.data?.message);
        } catch (error) {
            console.log('Error submitting user attempt:', error);
        }
    };
    // const handleSubmit = async () => {
    //   await submitUserAttempt();
    //   setShowSubmitMessage(true);
    // };

    const handleSubmit = async () => {
        await submitUserAttempt();
        setAttemptedQuestions(attemptedQuestions + 1);
        setShowSubmitMessage(true);
        const selectedOptionData = currentQuestion.options.find(
            option => option.option_id === selectedOption,
        );
        navigate('Question1', {
            question: currentQuestion.question_text,
            selectedOption: selectedOption,
            allOptions: currentQuestion.options,
            currentQuestion,
            quizData,
            category_id,
            isCorrect: selectedOptionData.is_correct,
        });

        setShowSubmitMessage(true);
    };

    const handleNextQuestion = () => {
        if (currentQuestionIndex < quizData.length - 1) {
            setCurrentQuestionIndex(currentQuestionIndex + 1);
            setShowSubmitMessage(false);
            setSelectedOption(null);
        }
        else {
            // Navigate to FinishQuiz when there are no more questions
            navigate('/thank-you-quiz', {
                category_id: categoryId,
            });
        }
    };

    // const handleStartNewQuiz = () => {

    //   if (currentQuestionIndex < quizData.length - 1) {
    //     setCurrentQuestionIndex(currentQuestionIndex + 1);
    //     setShowSubmitMessage(false);
    //     setSelectedOption(null);
    //   } else if (hasMoreQuestions) {
    //     setCurrentPage(nextPage => nextPage + 1);
    //     setShowSubmitMessage(false);
    //     setSelectedOption(null);
    //   }
    // };

    const currentQuestion = quizData[currentQuestionIndex];
    const progress22 = `${currentQuestionIndex + 1}/${quizData.length}`;

    // if (isLoading) {
    //     return (
    //         <View style={styles.LoadingImageDiv}>
    //             <Image source={LoadingImage} style={styles.LoadingImageCss} />
    //         </View>
    //     );
    // }
    const formatTime = seconds => {
        const mins = Math.floor(seconds / 60);
        const secs = seconds % 60;
        return `${mins}:${secs < 10 ? '0' : ''}${secs}`;
    };
    const handleMoveToQuestion = () => {
        if (currentQuestionIndex < quizData.length - 1) {
            setCurrentQuestionIndex(currentQuestionIndex + 1);
            navigate('Question1', {
                category_id: category_id,
            });
        } else {
            navigate('FinishQuiz', {
                category_id: category_id,
            });
        }
        setShowSubmitMessage(false);
    };
    const handleStartNewQuiz = () => {
        if (currentQuestionIndex < quizData.length - 1) {
            // Move to the next question
            setCurrentQuestionIndex(currentQuestionIndex + 1);
            setShowSubmitMessage(false);
            setSelectedOption(null);
        } else if (hasMoreQuestions) {
            // Load more questions
            setCurrentPage(nextPage => nextPage + 1);
            setShowSubmitMessage(true);
            // setSelectedOption(null);
        } else {
            // Navigate to FinishQuiz when there are no more questions
            navigate('FinishQuiz', {
                category_id: category_id,
            });
        }
    };
    return (
        <div className="pratice-page-container">
            <div className="header_inner">
                <div className="container">
                    <div className="row">
                        <div className="col-md-12">
                            <ArrowBackIosIcon onClick={() => navigate('/new-learning-journey')} className="icon_1" />
                            {SelectLanguageLocal === "hindi" ? (
                            <h2>लिखने का अभ्यास</h2>
                            ) : (
                            <h2>Writing Quiz</h2>
                            )}
                            <ChatBubbleOutlineIcon onClick={() => navigate('/chat-with-staff')} className="logo_1" style={{ cursor: 'pointer', color: '#ffc0cb' }} />
                        </div>
                    </div>
                </div>
            </div>

            {/* Centered 80% width wrapper */}
            <div style={{ width: '80%', margin: '0 auto' }}>
                <div className="pratice-page-rectangleBox">

                    {/* Character Learning Section — VIDEO + BUTTONS FIRST */}
                    <div className="pratice-page-section">
                        {SelectLanguageLocal === "hindi" ? (
                            <h2 className="pratice-page-header">शब्द सीखना</h2>
                        ) : (
                            <h2 className="pratice-page-header">Character Learning</h2>
                        )}
                        <h2 className="pratice-page-subHeader">
                            {currentQuestion && currentQuestion.question_text ? (() => {
                                const segments = parseQuestionText(currentQuestion.question_text);
                                return segments.map((segment, index) => (
                                    <React.Fragment key={index}>
                                        {segment}
                                        {index < segments.length - 1 && <br />}
                                    </React.Fragment>
                                ));
                            })() : "Loading..."}
                        </h2>
                        <div className="pratice-page-videoContainer">
                            {currentQuestion && currentQuestion.url ? (
                                <video
                                    className="pratice-page-videoPlayer"
                                    src={currentQuestion.url}
                                    autoPlay
                                    ref={videoRef}
                                    onCanPlay={(e) => { e.target.playbackRate = 2; }}
                                    onPlay={(e) => { e.target.playbackRate = 2; }}
                                >
                                    Your browser does not support the video tag.
                                </video>
                            ) : (
                                <div className="pratice-page-videoUnavailable">
                                    <p>Video is not available.</p>
                                </div>
                            )}
                        </div>



                        {SelectLanguageLocal === "hindi" ? (
                        <div className="pratice-page-controls">
                            <button onClick={handleRepeatVideo} className="pratice-page-button">
                                दोहराएं
                            </button>
                            <button onClick={handleNextQuestion} className="pratice-page-button">
                                अगला सवाल
                            </button>
                        </div>
                        ) : (
                        <div className="pratice-page-controls">
                            <button onClick={handleRepeatVideo} className="pratice-page-button">
                                Repeat
                            </button>
                            <button onClick={handleNextQuestion} className="pratice-page-button">
                                Next Question
                            </button>
                        </div>
                        )}
                    </div>

                    {/* Drawing Practice Section — BELOW VIDEO, NO HEADING */}
                    <div className="pratice-page-section">
                        <div className="pratice-page-signaturePadContainer">
                            <div className="pratice-page-crossLineHorizontal"></div>
                            <div className="pratice-page-crossLineVertical"></div>
                            <SignaturePad
                                ref={signaturePadRef}
                                options={{
                                    minWidth: 1,
                                    maxWidth: 3,
                                    penColor: "black",
                                }}
                                canvasProps={{
                                    width: "100%",
                                    height: "100%",
                                    className: "pratice-page-signature-canvas",
                                }}
                            />
                        </div>
                        <div className="pratice-page-controls">
                            <div onClick={handleClear} className="pratice-page-controlIcon">
                                <ClearIcon />
                            </div>
                            <div onClick={handleUndo} className="pratice-page-controlIcon">
                                <ReplayIcon />
                            </div>
                        </div>
                    </div>

                </div>
            </div>

      <Footer />
    </div>
  );
}

export default WritingPratice;